import React, { useState } from 'react';
import { Colors, Images } from 'utils';
import { getToken } from 'utils/crypto';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import { buttonsStyle } from '../../../../components/buttons/styles';
import { MinLoader } from '../../../../components';

export const DownloadInvoicePdf = ({}) => {
    const classes = buttonsStyle();
    const [loader, setLoader] = useState(false);
    const [previewLoader, setPreviewLoader] = useState(false);
    const params = useParams();
    const token = getToken();

    const saveFile = async () => {
        setLoader(true);
        axios({
            url: `/invoice/${params?.id}/pdf`,
            method: 'GET',
            responseType: 'blob',
            headers: { 'access-token': `${token}` },
        })
            .then((response) => {
                setLoader(false);

                const url = window.URL.createObjectURL(new Blob([response?.data]));
                const link = document.createElement('a');

                link.href = url;
                const fileName = response.headers['x-file-name'] ? decodeURIComponent(response.headers['x-file-name']) : 'invoice';
                link.setAttribute('download', `${fileName}.pdf`);
                document.body.appendChild(link);
                link.click();
            })
            .catch(() => setLoader(false));
    };

    const previewFile = async () => {
        setPreviewLoader(true);
        axios({
            url: `/invoice/${params?.id}/pdf`,
            method: 'GET',
            responseType: 'blob',
            headers: { 'access-token': `${token}` },
        })
            .then((response) => {
                setPreviewLoader(false);
                const blob = new Blob([response?.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank');
                setTimeout(() => window.URL.revokeObjectURL(url), 60000);
            })
            .catch(() => setPreviewLoader(false));
    };

    return (
        <div className='flex-align-center' style={{gap: 12}}>
            <button
                style={{ border: 'none', background: 'transparent', cursor: 'transparent', padding: 0, width: '89px' }}
                className={classes.downloadPdfBtn}
                onClick={saveFile}
            >
                <>
                    Download
                    {loader ? (
                        <CircularProgress style={{
                            color: Colors.BackgroundBlue,
                            width: '15px',
                            height: '15px',
                            marginLeft: '8px'
                        }} />
                    ) : (
                        <img src={Images.downloadCloud} alt="" />
                    )}
                </>
            </button>

            <button onClick={previewFile} className="reset-btn-by-default" style={{ height: 15, width: 15 }}>
                {previewLoader ? (
                    <MinLoader color={'#0C66E4'} small={true} margin={'0'} position={'relative'} />
                ) : (
                    <img src={Images.showAyeBlue} alt="" />
                )}
            </button>

        </div>
    );
};

